import {API_URL} from "@/utils/const";
import axios from "axios";
import authHeader from "@/services/data.service";

const initialFields = JSON.parse(localStorage.getItem("fields"));

const initialState = initialFields
    ? { fields: initialFields }
    : {
        fields: {
            typecodes: null,
            colors: null,
            second_colors: null,
            finishes: null,
            alt_finishes: null,
            second_finishes: null,
            sizes: null,
            thicknesses: null,
            lenghts: null,
            widths: null,
            collections: null,
            warehouses: null
        },
        // loading: {},
        loading: false,
        error: {}
    };

export const fields = {
    namespaced: true,
    state: initialState,
    getters: {
        tipi: (state) => state.fields.typecodes,
        colori1: (state) => state.fields.colors,
        colori2: (state) => state.fields.second_colors,
        finiture: (state) => state.fields.finishes,
        finiture1: (state) => state.fields.alt_finishes,
        finiture2: (state) => state.fields.second_finishes,
        dimensioni: (state) => state.fields.sizes,
        spessori: (state) => state.fields.thicknesses,
        lunghezze: (state) => state.fields.lenghts,
        larghezze: (state) => state.fields.widths,
        collezioni: (state) => state.fields.collections,
        magazzini: (state) => state.fields.warehouses,
        // getField: (state) => (key) => state.fields[key],
        // isLoading: (state) => (key) => !!state.loading[key]
        isLoading: (state) => !!state.loading
    },
    mutations: {
        SET_FIELD(state, { key, data }) {
            state.fields[key] = data;
        },
        SET_LOADING(state, data) {
            // state.loading[key] = data;
            state.loading = data;
        },
        SET_ERROR(state, {key, data }) {
            state.error[key] = data;
        }
    },
    actions: {
        async fetchAll({ dispatch, getters }) {
            await dispatch("fetchField", {key: "typecodes", endpoint: "tipi"});
            await dispatch("fetchField", {key: "colors", endpoint: "colori1"});
            await dispatch("fetchField", {key: "second_colors", endpoint: "colori2"});
            await dispatch("fetchFinishes");
            if (!getters.finiture) {
                await dispatch("fetchField", {key: "alt_finishes", endpoint: "finiture1"});
                await dispatch("fetchField", {key: "second_finishes", endpoint: "finiture2"});
            }
            await dispatch("fetchField", {key: "sizes", endpoint: "dimensioni"});
            await dispatch("fetchField", {key: "thicknesses", endpoint: "spessori"});
            await dispatch("fetchField", {key: "lenghts", endpoint: "lunghezze"});
            await dispatch("fetchField", {key: "widths", endpoint: "larghezze"});
            await dispatch("fetchField", {key: "collections", endpoint: "collezioni"});
            await dispatch("fetchWarehouses");

            await dispatch("saveLocal");
        },
        async saveLocal({state}) {
            localStorage.setItem('fields', JSON.stringify(state.fields));
        },
        async fetchField({ state, commit }, { key, endpoint }) {
            if (state.fields[key]) return state.fields[key];

            // commit("SET_LOADING", { key, value: true });
            commit("SET_LOADING", true);

            try {
                const { data: { data } } = await axios.get(API_URL + "prod/" + endpoint, {
                    headers: authHeader()
                });

                commit("SET_FIELD", { key, data });
                return data;
            } catch (err) {
                commit("SET_ERROR", { key, err });
                throw err;
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async fetchFinishes({ state, commit }) {
            if (state.fields.finishes) return state.fields.finishes;

            commit("SET_LOADING", true);

            try {
                const { data } = await axios.get(API_URL + "finiture/search-field", {
                    headers: authHeader()
                });

                commit("SET_FIELD", { key: "finishes", data });
                return data;
            } catch (err) {
                commit("SET_ERROR", { key: "finishes", err });
                throw err;
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async fetchWarehouses({ state, commit }) {
            if (state.fields.warehouses) return state.fields.warehouses;

            commit("SET_LOADING", true);

            try {
                const { data: { data } } = await axios.get(API_URL + "contacts/warehouses/all", {
                    headers: authHeader()
                });

                commit("SET_FIELD", { key: "warehouses", data });
                return data;
            } catch (err) {
                commit("SET_ERROR", { key: "warehouses", err });
                throw err;
            } finally {
                commit("SET_LOADING", false);
            }
        }
    }
}